import { PayloadAction } from '@reduxjs/toolkit';
import { PaginatedData } from '@common/model';
import { Ride } from '@features/rides/model/Ride';
import { PartnerState } from '../model';
import { FailureResponse } from '@common/model';

export const getPartnerRidesInit = (
  state: PartnerState,
  action: PayloadAction<{
    partnerId: number;
    dateFrom: string;
    dateTo: string;
    page?: number;
    showTotalItems?: number;
  }>,
) => {};
export const getPartnerRidesSuccess = (
  state: PartnerState,
  action: PayloadAction<PaginatedData<Ride>>,
) => {};
export const getPartnerRidesFailure = (
  state: PartnerState,
  action: PayloadAction<FailureResponse>,
) => {};
